<template>
  <vs-popup
    fullscreen
    :active="isEditingCalculated"
    title="Edit Skill"
    v-on:update:active="isEditingUpdated"
  >
    <div class="vx-row">
      <vs-input
        class="vx-col w-full lg:w-1/1"
        label-placeholder="Skill Name"
        v-model="SkillName"
      />
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-1">
        <vs-input
          label-placeholder="Estimated hours"
          class="w-full"
          v-model="EstimatedHours"
        />
      </div>
      <div class="vx-col sm:w-3/4 w-full mb-3">
        <vs-input label-placeholder="Slug" class="w-full" v-model="Slug" />
      </div>
    </div>
    <div style="min-height: 210px" class="vx-card">
      <br /><br />
      <div id="editor1" style="min-height: 200px"></div>
    </div>
    <quillEditor v-model="SkillDescription"></quillEditor><br />
    <quillEditor v-model="SelfAssessmentGuideline"></quillEditor><br />
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-1">
        <vs-checkbox v-model="AllowManualScoring"
          >Allow manual scoring</vs-checkbox
        >
      </div>
    </div>
    Tags:<br />
    <RelatedItemsDropdown
      @update:selectedItems="tagsUpdated"
      :selectedItems="selectedTags"
      RelatedItemsType="DataModel.TCVelik.Taxonomy.TCTag"
      RelatedParentType="DataModel.TCVelik.Skill.TCSkill"
      :RelatedParentId="Id"
      typeName="DataModel.TCVelik.Skill.TCSkill"
      :GetItemsPromise="tagsService.getTags"
      :commitItemsPromise="tagsService.commitTags"
    ></RelatedItemsDropdown>
    <vs-button
      color="primary"
      type="filled"
      style="margin-top: 10px"
      @click="save"
      class="mb-3"
      >Save</vs-button
    >
  </vs-popup>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import SkillsService from "@/skills/skillsService.js";
import * as monaco from "monaco-editor";
import RelatedItemsDropdown from "@/views/components/extra-components/RelatedItems/RelatedItemsDropdown.vue";
import TagsService from "@/tags/tagsService.js";

export default {
  data() {
    return {
      category: null,
      showEditor: true,
      editor: null,
      isEditingPrivate: false,
      Id: null,
      SkillName: null,
      SkillDescription: null,
      SkillQuery: null,
      SelfAssessmentGuideline: null,
      parentCategoryNodeInternal: null,
      allExcercises: [],
      selectedExcercises: [],
      selectedTags: [],
      EstimatedHours: 0,
      Slug: null,
      tagsService: TagsService,
      AllowManualScoring: false,
    };
  },
  methods: {
    isEditingUpdated(val) {
      this.$emit("updated", val);
    },
    tagsUpdated(newVal) {
      this.$set(this, "selectedTags", newVal);
    },
    save() {
      var instance = this;
      var skill = {
        DirectMapping: {
          Id: this.Id,
          SkillName: this.SkillName,
          SkillDescription: this.SkillDescription,
          SkillQuery: this.editor.getValue(),
          SelfAssessmentGuideline: this.SelfAssessmentGuideline,
          EstimatedHours: this.EstimatedHours,
          RelatedTags: this.selectedTags,
          Slug: this.Slug,
          AllowManualScoring: this.AllowManualScoring,
        },
        Relations: {
          ParentId: this.parentCategoryNodeInternal.data.FullData.Id,
        },
      };

      SkillsService.saveSkill(skill).then(function (response) {
        instance.$vs.notify({
          title: "Success",
          text: "Skill " + response.data.SkillName + " was saved successfully.",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });

        var updatedObj = {
          isVisible: false,
          updatedObj: response.data,
        };

        response.data.Type = "Skill";
        response.data.FullData = response.data;

        if (instance.Id < 1) {
          instance.parentCategoryNodeInternal.append({
            text: response.data.SkillName,
            id: response.data.FullData.Id,
            data: response.data,
          });
        }

        instance.$emit("updated", updatedObj);

        instance.resetEditor();
      });
    },
    resetEditor() {
      var instance = this;

      instance.$set(instance, "category", null);
      instance.$set(instance, "selectedTags", []);
      instance.$set(instance, "SelfAssessmentGuideline", null);
      instance.$set(instance, "SkillName", null);
      instance.$set(instance, "Id", null);
      instance.$set(instance, "SkillDescription", null);
      instance.$set(instance, "SkillQuery", null);
      instance.$set(instance, "parentCategoryNodeInternal", null); // The correct way is to emit event, handle it in the parent..bundleRenderer.renderToStream
      instance.$set(instance, "allExcercises", []);
      instance.$set(instance, "selectedExcercises", []);
      instance.$set(instance, "EstimatedHours", 0);
      instance.$set(instance, "Slug", null);
      instance.$set(instance, "AllowManualScoring", false);
      instance.tagsUpdated([]);

      instance.$emit("editorReset", null);

    },
  },
  props: ["isEditing", "skillId", "parentCategoryNode"],
  mounted() {
    this.isEditingPrivate = this.isEditing;
    this.editor = monaco.editor.create(document.getElementById("editor1"), {
      value: "",
      language: "csharp",
      automaticLayout: true,
    });
  },
  watch: {
    isEditing: function (val) {
      if (val === false) {
        this.resetEditor();
      }
    },
    skillId: function (newId) {
      var instance = this;
      if (newId > 0) {
        SkillsService.getSkillById(newId).then(function (response) {
          response.data.FullData = response.data;
          instance.SkillName = response.data.SkillName;
          instance.SkillDescription = response.data.SkillDescription;
          instance.SelfAssessmentGuideline =
            response.data.SelfAssessmentGuideline;
          instance.SkillQuery = response.data.SkillQuery;
          instance.EstimatedHours = response.data.EstimatedHours;
          instance.Id = response.data.FullData.Id;
          instance.editor.setValue(response.data.SkillQuery);
          instance.Slug = response.data.Slug;
          instance.AllowManualScoring = response.data.AllowManualScoring;
          instance.$set(
            instance,
            "selectedTags",
            response.data.RelatedTags ? response.data.RelatedTags : []
          );
        });
      } else {
        instance.SkillName = "";
        instance.SkillQuery = "";
        instance.editor.setValue("");
        instance.EstimatedHours = 0;
        instance.SelfAssessmentGuideline = "";
        (instance.RelatedTags = []), (instance.AllowManualScoring = false);
        (instance.Slug = null), (instance.Id = -1);
      }
    },
    parentCategoryNode: function (newVal) {
      this.parentCategoryNodeInternal = newVal;
    },
  },
  computed: {
    isEditingCalculated: function () {
      return this.isEditing && this.isEditing.isEdit
        ? this.isEditing.isEdit
        : false;
    },
  },
  components: {
    quillEditor,
    monaco,
    RelatedItemsDropdown,
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 250px;
}
</style>
